import React, { PropsWithChildren } from 'react'
import { useTranslation } from 'react-i18next'
import { Text } from '@node-space/ui-components'

export const InputLabelOptionalTag = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation()

  return (
    <Text tag="span" color="subdued" className="pl-1">
      {children ?? t('ifApplicable')}
    </Text>
  )
}
